import { render, staticRenderFns } from "./ListProvider.vue?vue&type=template&id=6568ad4a&"
import script from "./ListProvider.vue?vue&type=script&lang=js&"
export * from "./ListProvider.vue?vue&type=script&lang=js&"
import style0 from "./ListProvider.vue?vue&type=style&index=0&id=6568ad4a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports